import React from "react";
import ReactPlayer from "react-player";
import ColoredDivider from "views/ColoredDivider/ColoredDivider";

export default function ResponsiveReactPlayer({
  muted,
  playing,
  controls,
  width,
  height,
  url,
  dividerUp,
  dividerDown,
  loop,
  onClick,
}) {
  return (
    <div className="player-wrapper">
      {dividerUp && <ColoredDivider />}
      <ReactPlayer
        className="react-player"
        muted={muted}
        playing={playing}
        controls={controls}
        url={url}
        width={width}
        height={height}
        loop={loop}
        onPause={onClick}
      />
      {dividerDown && <ColoredDivider padding="2px" />}
    </div>
  );
}
